import HeaderRouteIndicator from "../../Molecules/HeaderRouteIndicator/HeaderRouteIndicator";
import FormShell from "../../Organisms/FormShell/FormShell";
import PostulacionFormik from "../../Organisms/PostulacionFormik/PostulacionFormik";
import usePost from "../../../hooks/usePost";
import ReactMarkdown from "react-markdown";
import OtherNews from "../../Organisms/OtherNews/OtherNews";
import Loader from "../../Atoms/Loader/Loader";
import capitalizedFirstLetter from "../../../Services/capitalizedFirstLetter";
import { useScrollCtx } from "../../../store/providers/ScrollContext";
import ChangeableHeaderV2 from "../../Molecules/ChangeableHeaderV2/ChangeableHeaderV2";

const Postulaciones = ({ params }) => {
	const { post, loading } = usePost("carrera", params.id);
	const { dropdownHeader } = useScrollCtx();

	return (
		<>
			<ChangeableHeaderV2 basic appearSecondNavbar={dropdownHeader} />

			{loading && !post ? (
				<div className="mt-200">
					<Loader />
				</div>
			) : (
				<>
					<HeaderRouteIndicator
						route={[
							{ text: "INICIO", route: "/" },
							{ text: "CARRERAS", route: "/carreras" },
							{ text: post.titulo_esp.toUpperCase(), route: undefined },
						]}
					/>
					<div className="hypertext-width top-space-section">
						<h5 className="t5 c-yellow">
							{new Date(post.createdAt).toLocaleDateString()}
						</h5>
						<h2 className="t2">{capitalizedFirstLetter(post.titulo_esp)}</h2>
						<ReactMarkdown>{post.contenido_esp}</ReactMarkdown>
					</div>

					<div className="top-space-section bottom-space-section">
						<FormShell whiteBg oneSide title="Formulario de Postulación">
							<PostulacionFormik />
						</FormShell>
					</div>

					<OtherNews toGet="carreras" postulacionesCase slug={params.id} />
				</>
			)}
		</>
	);
};

export default Postulaciones;
